export default {
    general: {
        add:      'Add',
        edit:     'Edit',
        cancel:   'Cancel',
        save:     'Save',
        delete:   'Delete',
        confirm:  'Confirm',
        logout:   'Log out',
        login:    'Log in',
        settings: 'Settings',
        language: 'Language',
        theme:    'Theme',
        actions:  'Actions',
        all:      'All',
    },
    todo: {
        todos:          'Todos',
        title:          'Title',
        description:    'Description',
        status:         'Status',
        due_at:         'Due',
        add:            'Add todo',
        edit:           'Edit todo',
        complete:       'Complete',
        confirm_delete: 'Delete this todo?',
        no_todos:       'No todos',
    },
    theme: {
        auto: 'System',
        light: 'Light',
        dark: 'Dark',
    },
    status: {
        open:        'Open',
        in_progress: 'In progress',
        done:        'Done',
    },
    login: {
        username: 'Username',
        password: 'Password',
        failed:   'Wrong username or password',
    },
    errors: {
        generic_error:    'An error occurred',
        invalid_data:     'Invalid data',
        not_found:        'Not found',
        unauthorized:     'Unauthorized',
        incorrect_status: 'Incorrect todo status',
        on_add:           'Error while adding',
        on_edit:          'Error while updating',
        on_delete:        'Error while deleting',
    },
    success: {
        add:      'Successfully added',
        edit:     'Successfully updated',
        delete:   'Successfully deleted',
        complete: 'Todo completed',
    },
    validation: {
        required:   'This field is required',
        max_length: 'Value is too long',
    },
}
